import React from "react"
import { translate } from "../../utils/language"
import { renderMarkdown } from "../../utils/rendermarkdown"

export const BlogpostText = ({data, language}) => {
    return <div>
        <p>{renderMarkdown(translate(language, data.Deutsch, data.Englisch))}</p>
    </div>
    }